class ShowMore extends HTMLElement {
  constructor() {
    super();
    this.container = document.querySelector(`${this.dataset.targetWrapper}`);
    this.url = this.getAttribute('data-next-page-url');
    this.button = this.querySelector('button');

    this.init();
  }

  init() {
    if (!this.container || !this.url) return;

    this.button.addEventListener('click',  (event) => {
      this.getData(this, event);
    });

    this.button.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        this.getData(this, event);
      }
    });
  }

  getData() {
    fetch(this.url)
      .then(response => response.text())
      .then((responseText) => {
        const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');

        this.addProducts(parsedHTML);
        this.changeUrl(parsedHTML);
      });
  }

  addProducts(html) {
    const productCards = html.querySelectorAll('.grid-item');
    let productCardsToRender = Array.from(productCards);
    productCardsToRender.forEach((element) => {
      this.container.append(element);
    });
  }

  changeUrl(html) {
    const btn = html.querySelector('[data-next-page-url]') || null;


    console.log(btn)
    this.url = btn ? btn.getAttribute('data-next-page-url') :  null;

    if (!this.url) {
      this.classList.add('hidden');
      return false;
    }

    this.setAttribute('data-next-page-url', this.url);
  }
}
customElements.define('show-more', ShowMore);
